/**
 * Background Lens work uses these internal briefs to generate data and card
 * insights. They are model instructions, not questions a person asked in a
 * Thread.
 */
const INTERNAL_LENS_INSTRUCTION_PREFIXES = [
  'Write one BigQuery query for an LE Lens dataset.',
  'Write one BigQuery query for a new LE Lens dataset',
  // Card generation deliberately sends the model a much longer brief than a
  // person would ever type. Older sessions were not reliably stamped
  // `humanInitiated: false`, so recognise the stable generator opening as a
  // second defence at both the history boundary and when a saved thread opens.
  'Create a single LE Lens ',
  'Rewrite this LE Lens dataset',
  'A reader is replacing',
  'Modify this existing LE Lens ',
  'An LE Lens ',
  'You are designing an LE Lens analytics dashboard',
  'These cards were planned for one LE Lens dashboard',
  'Answer this dashboard insight concisely,',
] as const;

export function isInternalLensInstruction(text: string | undefined): boolean {
  const instruction = text?.trim();
  return Boolean(instruction && INTERNAL_LENS_INSTRUCTION_PREFIXES.some((prefix) => instruction.startsWith(prefix)));
}
